import React, { useEffect, useState, forwardRef, useRef } from "react";
import { Input, Select, Form, Card, Button, Collapse } from "antd";
import FeatherIcon from "feather-icons-react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  createPrintOrder,
  updatePrintOrder,
  uploadPrintOrderFile,
  getPrintOrderById,
  deletePrintOrderFile,
  createPrintOrderItem,
  updatePrintOrderItem,
  deletePrintOrderItem,
} from "../../core/api/products";
import { X, PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  fetchBrandsBySelectedClients,
  getAllStatus,
  getSuppliersByType,
} from "../../core/api/settings";
import {
  getMarketingFilesNotLinkedToMarketing,
  getOffersByBrand,
} from "../../core/api/marketing";
import OfferDetailsView from "../Marketing/offerPreview";
const { Option } = Select;

const PrintOrderDetails = forwardRef(
  (
    {
      isVisible,
      onClose,
      printOrderId,
      setPrintOrderId,
      fetchPrintOrderList,
      onResize,
      clientId,
    },
    ref
  ) => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [orderForm] = Form.useForm();
    const [printOrderItemForm] = Form.useForm();
    const [summaryData, setSummaryData] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [brands, setBrands] = useState([]);
    const [existingFiles, setExistingFiles] = useState([]);
    const [newFiles, setNewFiles] = useState([]);
    const [printers, setPrinters] = useState([]);
    const [mailingOffers, setMailingOffers] = useState([]);
    const [envelopes, setEnvelopes] = useState([]);

    const [printOrderItems, setPrintOrderItems] = useState([
      {
        printType: "default",
        offer: null,
        envelopeType: null,
        marketing_file: null,
        quantity: 0,
        total_cost: 0,
      },
    ]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const creationStatusResponse = await getAllStatus();
          setStatuses(creationStatusResponse.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }, [clientId]);

    useEffect(() => {
      const fetchBrands = async () => {
        try {
          if (clientId) {
            const response = await fetchBrandsBySelectedClients([clientId]);
            setBrands(response.data);
          }
        } catch (err) {
          console.error("Failed to fetch brands", err);
        }
      };

      fetchBrands();
    }, [clientId]);

    const handlePreviewClick = (url) => {
      window.open(url, "_blank");
    };
    const MySwal = withReactContent(Swal);

    const handleBrandChange = async (value) => {
      if (value) {
        const offersRes = await getOffersByBrand(value);
        setMailingOffers(offersRes.data);
        const supplierResponse = await getSuppliersByType(  value );
        console.log( "supplier response", supplierResponse )
        console.log("value",value)
        setPrinters(supplierResponse.data);
      }
    };

    const handleEnvelopeTypeChange = async (type_name) => {
      if (type_name) {
        const envelopesRes = await getMarketingFilesNotLinkedToMarketing(
          type_name
        );
        setEnvelopes(envelopesRes.data);
      }
    };

    const handleRemoveFile = (file, isNew = false) => {
      if (isNew) {
        setNewFiles((prevFiles) => prevFiles.filter((f) => f !== file));
      } else {
        MySwal.fire({
          title: "Are you sure?",
          text: "This action will permanently delete the file from the database.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await deletePrintOrderFile(file.id);
              setExistingFiles((prevFiles) =>
                prevFiles.filter((f) => f.id !== file.id)
              );

              MySwal.fire("Deleted!", "The file has been deleted.", "success");
            } catch (error) {
              console.error("Error deleting file:", error);
              MySwal.fire("Error", "Failed to delete the file.", "error");
            }
          }
        });
      }
    };
    useEffect(() => {
      const sidebarWidth = isFullScreen ? window.innerWidth * 0.6 : 555;
      onResize(sidebarWidth);
    }, [isFullScreen, onResize]);

    const resetState = () => {
      orderForm.resetFields();
      printOrderItemForm.resetFields();
      setExistingFiles([]);
      setNewFiles([]);
      setIsFullScreen(false);
      setSummaryData([]);
      setPrintOrderItems( [ {
        printType: "default",
        offer: null,
        envelopeType: null,
        marketing_file: null,
        quantity: 0,
        total_cost: 0,
      } ] );
    };

    const addPrintOrderItem = () => {
      setPrintOrderItems([
        ...printOrderItems,
        {
          printType: "default",
          offer: null,
          envelopeType: null,
          marketing_file: null,
          quantity: 0,
          total_cost: 0,
        },
      ]);
    };
    const updatePrintOrderItemFunction = (index, updatedItem) => {
      const updatedItems = [...printOrderItems];
      updatedItems[index] = { ...updatedItems[index], ...updatedItem };
      setPrintOrderItems(updatedItems);
    };
    const deletePrintOrderItemFunction = async (index) => {
      try {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "This action will permanently delete the print document.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
          if (printOrderItems[index].id) {
            await deletePrintOrderItem(printOrderItems[index].id);
            fetchPrintOrderDetails();
          } else {
            const updatedItems = [...printOrderItems];
            updatedItems.splice(index, 1);
            setPrintOrderItems( updatedItems );
            setSummaryData(updatedItems)
          }

          Swal.fire(
            "Deleted!",
            "The print document has been deleted.",
            "success"
          );
        }
      } catch (error) {
        console.error("Error deleting print document:", error);
        Swal.fire("Error", "Failed to delete the print document.", "error");
      }
    };

    const savePrintDocument = async (index) => {
      const values = await printOrderItemForm.validateFields();
      try {
        
        const item = printOrderItems[index];
        const updatedItem = {
          ...item,
          printType: values[`printType_${index}`],
          offer: values[`offer_${index}`] || null,
          envelopeType: values[`envelopeType_${index}`] || null,
          marketing_file: values[`envelope_${index}`] || null,
          quantity: values[`quantity_${index}`] || 0,
          total_cost: values[`totalCost_${index}`] || 0,
        };
    
        updatePrintOrderItemFunction(index, updatedItem);
    
        // Enrich with details for summary table
        const enriched = {
          ...updatedItem,
          offer_detail: mailingOffers.find(o => o.id === updatedItem.offer),
          marketing_file_detail: envelopes.find(e => e.id === updatedItem.marketing_file),
        };
    
        const updatedSummary = [...summaryData];
        updatedSummary[index] = enriched;
        setSummaryData(updatedSummary);
      } catch (error) {
        console.error("Error saving document info:", error);
        Swal.fire("Error", "Failed to save document info. Please check fields.", "error");
      }
    };
    
    

    const fetchPrintOrderDetails = async () => {
      if (!printOrderId) return;

      try {
        const response = await getPrintOrderById(printOrderId);
        const printOrder = response.data;
        handleBrandChange(printOrder.brand);
        orderForm.setFieldsValue({
          printer: printOrder.printer || null,
          invoiceDate: printOrder.invoice_date || "",
          invoiceNumber: printOrder.invoice_number || "",
          status: printOrder.status || null,
          statusDescription: printOrder.status_description || "",
          brand: printOrder.brand || null,
        });
        setPrintOrderItems(printOrder.items);
        setSummaryData(printOrder.items);
        setExistingFiles(printOrder.order_files || []);
      } catch (error) {
        console.error("Error fetching print order details:", error);
        Swal.fire("Error", "Failed to fetch print order details.", "error");
      }
    };
    useEffect(() => {
      fetchPrintOrderDetails();
    }, [clientId, printOrderId]);

    const handleSubmitPrintOrder = async () => {
      try {
        const values = await orderForm.validateFields();
    
        const orderPayload = {
          printer: values.printer,
          invoice_date: values.invoiceDate,
          invoice_number: values.invoiceNumber,
          status: values.status,
          status_description: values.statusDescription || "",
          brand: values.brand,
        };
    
        let orderResponse;
        let updatedprintOrderId;
    
        if (printOrderId) {
          orderResponse = await updatePrintOrder(printOrderId, orderPayload);
          updatedprintOrderId = printOrderId;
        } else {
          orderResponse = await createPrintOrder(orderPayload);
          updatedprintOrderId = orderResponse.data.id;
          setPrintOrderId(updatedprintOrderId);
        }
    
        for (const item of printOrderItems) {
          const itemPayload = {
            printType: item.printType,
            offer: item.offer,
            envelopeType: item.envelopeType,
            marketing_file: item.marketing_file,
            quantity: item.quantity,
            total_cost: item.total_cost,
            print_order: updatedprintOrderId, 
          };
    
          if (item.id) {
            await updatePrintOrderItem(item.id, itemPayload);
          } else {
            const created = await createPrintOrderItem(itemPayload);
            item.id = created.data.id; 
          }
        }
    
        for (const file of newFiles) {
          await uploadPrintOrderFile(updatedprintOrderId, file.file);
        }
    
        await fetchPrintOrderDetails();
        fetchPrintOrderList();
    
        Swal.fire({
          title: "Success",
          text: printOrderId ? "Print Order updated successfully." : "Print Order created successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
    
      } catch (error) {
        console.error("Print Order submission error:", error);
        Swal.fire({
          title: "Error",
          text: "An error occurred while submitting the print order.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };    

    const data = useSelector((state) => state.toggle_header);

    const [offerId, setOfferId] = useState(null);
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const sidebarRef = useRef(null);
    const [isRightSideBarEditMode, setIsRightSideBarEditMode] = useState(false);
    const toggleSidebarEditMode = () => {
      setIsRightSideBarEditMode((prevMode) => !prevMode);
    };
    const handleCloseRightSideBar = () => {
      setSidebarVisible(false);
      setOfferId(null);
      setIsRightSideBarEditMode(false);
    };

    return (
      <div
        ref={ref}
        className={`right-sidebar ${isVisible ? "visible" : ""}`}
        style={{
          position: "fixed",
          top: data ? 0 : "66px",
          right: 0,
          height: "100%",
          zIndex: 1050,
          width: isFullScreen ? "60%" : "555px",
          backgroundColor: "#fff",
          boxShadow: "0 0 3px rgba(0, 0, 0, 0.6)",
          overflowY: "auto",
          transition: "transform 0.3s ease-in-out",
          transform: isVisible ? "translateX(0)" : "translateX(100%)",
        }}
      >
        <div
          className="sidebar-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "15px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <h5>
            {printOrderId ? "Edit Print Order" : "Create New Print Order"}
          </h5>
          <div>
            <button
              onClick={() => setIsFullScreen(!isFullScreen)}
              className="btn"
            >
              <FeatherIcon icon={isFullScreen ? "minimize" : "maximize"} />
            </button>
            <button
              className="btn"
              onClick={() => {
                resetState();
                onClose();
              }}
            >
              <X />
            </button>
          </div>
        </div>
        <div style={{ padding: "15px" }}>
          <Form form={orderForm} layout="vertical">
            <Card title="Order Creation Status">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                }}
              >
                <Form.Item
                  label="Creation Status"
                  name="status"
                  rules={[
                    { required: true, message: "Please select a status" },
                  ]}
                >
                  <Select placeholder="Select Status">
                    {statuses?.map((status) => (
                      <Option key={status.id} value={status.id}>
                        {status.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label="Status Description" name="statusDescription">
                  <Input.TextArea
                    rows={2}
                    placeholder="Enter status description"
                    allowClear
                  />
                </Form.Item>
              </div>
            </Card>
            <br />
            <Card title="Invoice">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "10px",
                }}
              >
                <Form.Item
                  label="Invoice Date"
                  name="invoiceDate"
                  initialValue={new Date().toISOString().split("T")[0]}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the invoice date",
                    },
                  ]}
                >
                  <Input type="date" />
                </Form.Item>
                <Form.Item
                  label="Invoice Number"
                  name={"invoiceNumber"}
                  rules={[
                    { required: true, message: "Please enter invoice number" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Brand"
                  name="brand"
                  rules={[{ required: true, message: "Please select brand" }]}
                >
                  <Select
                    placeholder="Select Brand"
                    onChange={(value) => {
                      handleBrandChange(value);
                    }}
                  >
                    {brands.map((brand) => (
                      <Option key={brand.id} value={brand.id}>
                        {brand.brand_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Printer"
                  name="printer"
                  rules={[{ required: true, message: "Please select printer" }]}
                >
                  <Select
                    placeholder="Select Printer"
                    loading={!printers.length}
                  >
                    {printers.map((printer) => (
                      <Option key={printer.id} value={printer.id}>
                        {printer.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </Card>
            <br />
          </Form>
          <div>
            <Form form={printOrderItemForm} layout="vertical">
              <Collapse accordion>
                {printOrderItems.map((item, index) => (
                  <Collapse.Panel
                    header={`Print Document ${index + 1}`}
                    key={index}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr 1fr",
                        gap: "10px",
                      }}
                    >
                      <Form.Item
                        label="Print Type"
                        name={`printType_${index}`}
                        initialValue={(() => {
                          if (item.printType !== "default" && item.offer) {
                            return "Marketing";
                          } else if (item.printType === "default") {
                            return null;
                          } else {
                            return "Envelope";
                          }
                        })()}
                        rules={[
                          {
                            required: true,
                            message: "Please select a print type",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Print Type"
                          value={item.printType}
                          onChange={(value) =>
                            updatePrintOrderItemFunction(index, {
                              printType: value,
                            })
                          }
                          allowClear
                          disabled={item.id ? true : false}
                        >
                          <Option value="Marketing">Marketing</Option>
                          <Option value="Envelope">Envelope</Option>
                        </Select>
                      </Form.Item>

                      {(item.printType === "Marketing" || item.offer) && (
                        <Form.Item
                          label="Offer"
                          name={`offer_${index}`}
                          rules={[
                            {
                              required: true,
                              message: "Please select an offer",
                            },
                          ]}
                          initialValue={item.offer}
                        >
                          <Select
                            placeholder="Select Offer"
                            value={item.offer}
                            onChange={(value) =>
                              updatePrintOrderItemFunction(index, {
                                offer: value,
                              })
                            }
                            disabled={item.id ? true : false}
                            dropdownRender={(menu) => (
                              <div>
                                {menu}
                                <style>
                                  {`
                               .offer-item {
                                 display: flex;
                                 justify-content: space-between;
                                 align-items: center;
                               }
                               .offer-item .feather-view {
                                 cursor: pointer ;
                                 color: blue ;
                               }
                               `}
                                </style>
                              </div>
                            )}
                          >
                            {mailingOffers.map((offer) => (
                              <Option key={offer.id} value={offer.id}>
                                <div className="offer-item">
                                  <span>{offer.code_offer + "  "}</span>
                                  <FeatherIcon
                                    icon="eye"
                                    className="feather-view"
                                    size={16}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setOfferId(offer.id);
                                      setSidebarVisible(true);
                                    }}
                                  />
                                </div>
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}

                      {(item.printType === "Envelope" ||
                        item.marketing_file) && (
                        <>
                          <Form.Item
                            label="Envelope Type"
                            name={`envelopeType_${index}`}
                            rules={[
                              {
                                required: true,
                                message: "Please select an envelope type",
                              },
                            ]}
                            initialValue={
                              item.marketing_file_detail?.type?.name
                            }
                          >
                            <Select
                              placeholder="Select Envelope Type"
                              value={item.envelopeType}
                              onChange={(value) => {
                                updatePrintOrderItemFunction(index, {
                                  envelopeType: value,
                                });
                                handleEnvelopeTypeChange(value);
                              }}
                              disabled={item.id ? true : false}
                            >
                              <Option value="Return Envelope">
                                Return Envelope
                              </Option>
                              <Option value="Outside Envelope">
                                Outside Envelope
                              </Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            label="Envelope"
                            name={`envelope_${index}`}
                            rules={[
                              {
                                required: true,
                                message: "Please select an envelope",
                              },
                            ]}
                            initialValue={item.marketing_file_detail?.id}
                          >
                            <Select
                              placeholder="Select Envelope"
                              value={item?.marketing_file}
                              onChange={(value) =>
                                updatePrintOrderItemFunction(index, {
                                  marketing_file: value,
                                })
                              }
                              disabled={item.id ? true : false}
                            >
                              {item?.marketing_file_detail?.file_name && (
                                <Option
                                  key={item?.marketing_file_detail?.id}
                                  value={item?.marketing_file_detail?.id}
                                >
                                  {item?.marketing_file_detail?.file_name}
                                </Option>
                              )}

                              {envelopes.map((envelope) => (
                                <Option key={envelope.id} value={envelope.id}>
                                  {envelope.file_name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </>
                      )}

                      <Form.Item
                        label="Quantity"
                        name={`quantity_${index}`}
                        rules={[
                          {
                            required: true,
                            message: "Please enter a quantity",
                          },
                        ]}
                        initialValue={item.quantity}
                      >
                        <Input
                          type="number"
                          value={item.quantity}
                          onChange={(e) =>
                            updatePrintOrderItemFunction(index, {
                              quantity: parseFloat(e.target.value) || 0,
                            })
                          }
                        />
                      </Form.Item>

                      <Form.Item
                        label="Total Cost"
                        name={`totalCost_${index}`}
                        initialValue={item.total_cost}
                        rules={[
                          {
                            required: true,
                            message: "Please enter the total cost",
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          value={item.total_cost}
                          onChange={(e) =>
                            updatePrintOrderItemFunction(index, {
                              total_cost: parseFloat(e.target.value) || 0,
                            })
                          }
                        />
                      </Form.Item>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        type="default"
                        onClick={() => deletePrintOrderItemFunction(index)}
                        className="btn btn-danger me-2"
                      >
                        Remove
                      </Button>
                      <Button
                        type="primary"
                        className="btn btn-primary"
                        onClick={() => savePrintDocument(index)}
                      >
                        Save
                      </Button>
                    </div>
                  </Collapse.Panel>
                ))}
              </Collapse>
              <br />
              <Button type="dashed" onClick={addPrintOrderItem} block>
                Add Print Document
              </Button>
            </Form>
          </div>
          <br />
          <Card title="Order Invoice Files">
            <div className="text-editor add-list add">
              <div className="col-lg-12">
                <div className="add-choosen">
                  <div className="input-blocks">
                    <div className="image-upload">
                      <input
                        type="file"
                        multiple
                        onChange={(event) => {
                          const input = event.target;
                          const files = Array.from(input.files);

                          setNewFiles((prevFiles) => [
                            ...prevFiles,
                            ...files.map((file) => ({
                              file,
                              preview: URL.createObjectURL(file),
                            })),
                          ]);
                          input.value = "";
                        }}
                        accept="application/pdf"
                      />
                      <div className="image-uploads">
                        <PlusCircle className="plus-down-add me-0" />
                        <h4>Upload Order Files</h4>
                      </div>
                    </div>
                  </div>

                  {/* Existing Files */}
                  {existingFiles?.length > 0 && (
                    <div className="existing-files mt-3">
                      <h6>Existing Files</h6>
                      <div className="d-flex flex-wrap">
                        {existingFiles.map((file) => (
                          <div key={file.id} className="phone-img">
                            <button
                              className="file-thumbnail"
                              type="button"
                              onClick={(event) => {
                                event.preventDefault();
                                handlePreviewClick(file.signed_file_url);
                              }}
                              style={{
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                              }}
                            >
                              <embed
                                src={file.signed_file_url}
                                type="application/pdf"
                                className="file-thumbnail"
                                width="100%"
                                height="200"
                              />
                            </button>
                            <Link to="#">
                              <X
                                className="x-square-add remove-product"
                                onClick={() => handleRemoveFile(file)}
                              />
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* New Files */}
                  {newFiles?.length > 0 && (
                    <div className="new-files mt-3">
                      <h6>New Files</h6>
                      <div className="d-flex flex-wrap">
                        {newFiles.map((fileObj, index) => (
                          <div key={index} className="phone-img">
                            <button
                              className="file-thumbnail"
                              type="button"
                              onClick={(event) => {
                                event.preventDefault();
                                handlePreviewClick(fileObj.preview);
                              }}
                            >
                              <embed
                                src={fileObj.preview}
                                type="application/pdf"
                                className="file-thumbnail"
                                width="100%"
                                height="200"
                              />
                              <div className="file-name">
                                {fileObj.file.name}
                              </div>
                            </button>
                            <Link to="#">
                              <X
                                className="x-square-add remove-product"
                                onClick={() => {
                                  URL.revokeObjectURL(fileObj.preview); // Cleanup URL
                                  setNewFiles((prevFiles) =>
                                    prevFiles.filter((f) => f !== fileObj)
                                  );
                                }}
                              />
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Card>
          <br />
          <Card title="Order Summary">
            <div className="table-responsive" style={{ overflowX: "scroll" }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Files</th>
                    <th>Qty of Order</th>
                    <th>Unit Cost</th>
                    <th>Total Cost</th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.offer
                          ? item.offer_detail.code_offer
                          : item.marketing_file_detail.file_code}
                      </td>
                      <td>
                        {item.offer ? (
                          <ul>
                            {item.offer_detail.offer_files.map(
                              (marketingFile) => (
                                <li key={marketingFile.id}>
                                  <Link
                                    onClick={() => {
                                      handlePreviewClick(
                                        marketingFile.absolute_url
                                      );
                                    }}
                                  >
                                    {marketingFile.file_name}
                                  </Link>
                                </li>
                              )
                            )}
                          </ul>
                        ) : (
                          <ul>
                            <li>
                              <Link
                                onClick={() =>
                                  handlePreviewClick(
                                    item.marketing_file_detail.file
                                  )
                                }
                              >
                                {" "}
                                {item.marketing_file_detail.file_name}
                              </Link>
                            </li>
                          </ul>
                        )}
                      </td>
                      <td>{item.quantity}</td>
                      <td>${(Number(item.total_cost) / Number(item.quantity))?.toFixed(3)}</td>
                      <td>{!isNaN(Number(item.total_cost)) ? Number(item.total_cost).toFixed(3) : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
          <div className="d-flex justify-content-end mt-3">
            <Button
              type="default"
              className="btn btn-secondary me-2"
              onClick={() => {
                orderForm.resetFields();
                setSummaryData([]);
                onClose();
              }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-submit"
              type="default"
              onClick={handleSubmitPrintOrder}
            >
              {printOrderId ? "Update Print Order" : "Save Print Order"}
            </Button>
          </div>
          <div style={{ height: "100px" }}></div>
        </div>
        {isSidebarVisible && (
          <OfferDetailsView
            isVisible={isSidebarVisible}
            onClose={handleCloseRightSideBar}
            offerId={offerId}
            clientId={clientId}
            ref={sidebarRef}
            editMode={isRightSideBarEditMode}
            toggleEdit={toggleSidebarEditMode}
            onResize={() => {
              // intentionally empty
            }}
          />
        )}
      </div>
    );
  }
);

PrintOrderDetails.displayName = "PrintOrderDetails";

export default PrintOrderDetails;
